import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import InputRadio from '../Symbols/InputRadio';
import InputCurrency from '../Symbols/InputCurrency';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import { childrenOptions } from './Options';
import InputSelect from '../Symbols/InputSelect';
import { YEARS } from '../LegalParameters/Constants';

const years = YEARS.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { monthlyInsurance = '', children = 1, childrenLimit = 1, year },
		ppm = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka mateřská pro OSVČ">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputCurrency
					label="Zadejte měsíční výši platby nemocenského pojištění:"
					onChange={changeHandler('monthlyInsurance')}
					onBlur={validateHandler('monthlyInsurance')}
					value={monthlyInsurance}
					error={errors.monthlyInsurance}
					passedProps={{ 'data-cy': 'monthlyInsurance' }}
				/>

				<InputRadio
					label="Kolik se vám má narodit dětí?:"
					name="children"
					radio={childrenOptions}
					onChange={changeHandler('children')}
					onBlur={validateHandler('children')}
					value={Math.max(children, childrenLimit)}
					passedProps={{ 'data-cy': 'children' }}
				/>
				<div css={Row}>
					<Button>Výpočet</Button>
				</div>
				{ppm && <Result ppm={ppm} year={year} />}
				{ppm && (
					<div css={Row}>
						<Button onClick={reset}>Nový výpočet</Button>
					</div>
				)}
				<Info css={Row}>
					<p>DVZ je Denní Vyměřovací Základ</p>

					<p>
						Výpočet měsíční mateřské je orientační, platí pro měsíc, který má 30 kalendářních dní.
					</p>

					<p>
						Peněžitá pomoc v mateřství se vyplácí maximálně 196 dní při narození 1 dítěte a
						maximálně 259 dní při narození 2 a více dětí.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
